module.exports = __webpack_public_path__ + "media/images/official/voice_sakuma-f3e672fc8be2388469006c25910f155c.png";